import FormSelectBox from '@views/components/Inputs/FormSelectBox';

import { useGetClasses } from '@/modules/entities';

export const ClassSelect = ({
  name = 'class',
  label,
  editMode = true,
  placeholder = 'Select Rating Class',
  rules = [],
  isRequired,
  dataTestId,
  ...rest
}) => {
  const { data, isLoading } = useGetClasses();

  const options = data?.list ?? [];

  return (
    <FormSelectBox
      name={name}
      label={label}
      editMode={editMode}
      placeholder={placeholder}
      rules={rules}
      isRequired={isRequired}
      dataTestId={dataTestId}
      options={options}
      loading={isLoading}
      {...rest}
    />
  );
};
